import {type BaseCardData} from '@colonist/game-card-types'
import {CardTypeEnum} from '@colonist/game-states'
import {ArrayUtils} from '@colonist/utils'

export class UIGameCardViewInventory {
    static getPartitionCardIndexes(cardsData: BaseCardData[]): number[] {
        const cardTypeWhichShouldCreateAPartition = [CardTypeEnum.AnyResource, CardTypeEnum.Development]
        const cardTypeArray = cardsData.map((cardData) => cardData.cardTypeEnum)

        const partitionIndexes: Set<number> = new Set()
        for(const cardType of cardTypeWhichShouldCreateAPartition) {
            const index = ArrayUtils.findIndexGreaterThanOrEqual(cardTypeArray, cardType)
            if(index == -1) continue
            partitionIndexes.add(index)
        }
        partitionIndexes.delete(0)

        return Array.from(partitionIndexes)
    }
}
